import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetVehicleFuelTypesRequest extends ValueObject {
  #context
  #makeId
  #modelId

  static validate({makeId, modelId}) {
    if (!makeId || !modelId) {
      throw InvalidParamsSharedError.create(
        `[GetVehicleFuelTypesRequest.validate] param makeId, modelId,   are required`
      )
    }
  }

  constructor({context, makeId, modelId}) {
    super()
    this.#context = context
    this.#makeId = makeId
    this.#modelId = modelId
  }

  static create({context, makeId, modelId}) {
    GetVehicleFuelTypesRequest.validate({makeId, modelId})
    return new GetVehicleFuelTypesRequest({
      context,
      makeId,
      modelId
    })
  }

  toJSON() {
    return {
      context: this.#context,
      makeId: this.#makeId,
      modelId: this.#modelId
    }
  }
}
